const fonts = {};

fonts.sansSerif =
  "'Neue Haas Grotesk', 'helvetica neue', helvetica, arial, sans-serif";
fonts.monospace =
  "'Roboto Mono', monospace";

export default fonts;
